import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormaDosaggioCriteria } from "../../model/FormaDosaggioCriteria";
import { ActivatedRoute, ParamMap, Params } from '@angular/router';

@Component({
  selector: 'app-filtri',
  templateUrl: './filtri.component.html',
  styleUrls: ['./filtri.component.scss']
})
export class FiltriComponent implements OnInit {

  countTrue = 0;
  disabilitaCarenza=false;
  disabilitaOrfano=false;
  isFilterPanelExpanded = true

  filterData: any = {
    dopante: { id: 1, si: false, no: false , label: 'Dopante'},
    soggettoAPrescrizione: { id: 2, si: false, no: false , label: 'Soggetto a prescrizione medica'},
    inCommercio: { id: 3, si: false, no: false, label: 'In commercio'},
    sospeso: { id: 4, si: false, no: false , label: 'Sospeso'},
    innovativo: { id: 5, si: false, no: false , label: 'Innovativo'},
    orfano: { id: 6, si: false, no: false , label: 'Orfano'},
    pianoTerapeutico: { id: 7, si: false, no: false ,label: 'Piano terapeutico'},
    carenza: { id: 8, si: false, no: false , label: 'Carenza'},
  };

  @Output() emitSearch: EventEmitter<any> = new EventEmitter<any>();

  @Input('urlFilter') set filters(f: any) {
    if (f)
      this._setParams(f);
  }

  @Input() query: any

  isSmallScreen = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isSmallScreen = window.innerWidth <= 1200;
  }

  getIsSmallScreen() {
    return window.innerWidth <= 1200;
  }


  ngOnInit(): void {
    this.manageFiltersSearch();
  }


  manageFiltersSearch() {
    this.countTrue = 0;
    for (const key in this.filterData) {
      if (this.filterData[key].si === true || this.filterData[key].no === true) {
        this.countTrue++;
      }
    }
  }

  emitSearchEvent() {
    const filters = new FormaDosaggioCriteria(this.filterData);
    this.emitSearch.emit(filters);
  }



  getDisabled(key: string) {
    let res = false
    if (!this.query)
      res = this.filterData[key].si
    return res;
  }

  _setParams(f: any) {
    for (const key of Object.keys(this.filterData)) {
      if (f[key] !== undefined) {
        this.filterData[key].si = JSON.parse(<string>f[key]);
        this.filterData[key].no = !JSON.parse(<string>f[key]);
      } else {
        this.filterData[key].si = false;
        this.filterData[key].no = false;
      }
    }
  }
constructor(private route:ActivatedRoute){
  this.route.queryParamMap.subscribe(
    (params: ParamMap) => {
      var query: string|null = params.get('query');
      var carenza: string |null= params.get('carenza');
      var orfano: string |null= params.get('orfano');
      if(!query){
      if(carenza==="true"&&this.disabilitaOrfano===false)
        this.disabilitaCarenza=true;
      else this.disabilitaCarenza=false;
       if(orfano==="true"&&this.disabilitaCarenza===false)
        this.disabilitaOrfano=true;
       else this.disabilitaOrfano=false;
       if(carenza==="true"&&orfano==="true"&&this.disabilitaOrfano===true)
       { this.disabilitaOrfano=true;
        this.disabilitaCarenza=false;
       }
       if(carenza==="true"&&orfano==="true"&&this.disabilitaCarenza===true)
       { this.disabilitaOrfano=false;
        this.disabilitaCarenza=true;
       }
       if(carenza==="true"&&orfano==="true"&&this.disabilitaCarenza===true&&this.disabilitaOrfano===true)
       { this.disabilitaOrfano=false;
        this.disabilitaCarenza=true;
       }

      }
    });
  }

}
